import { useRouter } from 'next/router'

import Box from 'app/components/base/Box'
import Center from 'app/components/base/Center'
import Container from 'app/components/base/Container'
import ReactHtmlParser from 'app/components/base/ReactHtmlParser'
import Spinner from 'app/components/base/Spinner'
import Text from 'app/components/base/Text'
import { useGetStaticPageQuery } from 'app/services/Query/static-pages/static-pages.query'

import NextSeo from '~/containers/NextSeo'

const StaticPageView: RFC = () => {
  const { query, push, isFallback } = useRouter()
  const slug = query?.slug as string

  const { data: staticPage } = useGetStaticPageQuery({
    slug,
    options: { enabled: false, onError: () => push('/') }
  })

  const { title, body, meta } = staticPage || {}
  const { meta_description, meta_title, meta_h1 } = meta || {}

  if (isFallback) {
    return (
      <Center minHeight={400}>
        <Spinner size={50} />
      </Center>
    )
  }

  return (
    <>
      <NextSeo
        title={meta_title}
        description={meta_description}
        openGraph={{ title: meta_title, description: meta_description }}
      />

      <Container>
        <Text component="h1" sx={{ display: 'none' }}>
          {meta_h1}
        </Text>

        <Text size={{ xs: 'h2', md: 'h1' }} textAlign="center" mt={5} mb={3}>
          {title}
        </Text>

        <Box maxWidth={730} m="0 auto" mb={10} sx={{ wordBreak: 'break-word' }}>
          <ReactHtmlParser data={String(body)} />
        </Box>
      </Container>
    </>
  )
}

export default StaticPageView
